export const CLAIM_STATUS_REJECTED = 1;
export const CLAIM_STATUS_CREATED = 2;
export const CLAIM_STATUS_SUBMITTED = 4;
export const CLAIM_STATUS_PROCESSED = 8;
export const CLAIM_STATUS_APPROVED = 16;
export const CLAIM_STATUS_REWORK = 32;
export const CLAIM_STATUS_PAID = 64;

export const claimStatusMapping = (t) => ({
  1: t("Rejected"),
  2: t("Created"),
  4: t("Submitted"),
  8: t("Processed"),
  16: t("Approved"),
  32: t("Rework"),
  64: t("Paid"),
  128: t("Contentieux"),
});

export const claimStatusStyles = {
  1: {color: "red"},
  2: {color: "gray"},
  4: {color: "orange"},
  8: {color: "blue"},
  16: {color: "green"},
  32: {color: "red"},
  64: {color: "green"},
  128: {color: "orange"},
};

export const claimChipColor = (claimStatus) => {
  switch (claimStatus) {
    case 1:
      return "error";
    case 2:
      return "default";
    case 4:
      return "info";
    case 8:
      return "primary";
    case 16:
      return "success";
    case 64:
      return "success";
    case 32:
      return "error";
    default:
      return "default";
  }
}

export const invoiceBadgeColor = (status) => {
  switch (status) {
    case "CREATED":
      return "default";
    case "SUBMITTED":
      return "primary";
    case "PROCESSING":
      return "warning";
    case "APPROVED":
      return "success";
    case "REJECTED":
      return "error";
    default:
      return "default";
  }
}

export const invoiceStatus = (status) => {
  switch (status) {
    case "CREATED":
      return "Créé";
    case "SUBMITTED":
      return "Soumis";
    case "PROCESSING":
      return "En cours de traitement";
    case "APPROVED":
      return "Approuvé";
    case "REJECTED":
      return "Rejeté";
    default:
      return status;
  }
}

export const invoiceTextColor = (status) => {
  switch (status) {
    case "CREATED":
      return "#757575";
    case "SUBMITTED":
      return "#1976d2";
    case "PROCESSING":
      return "#f57c00";
    case "APPROVED":
      return "#388e3c";
    case "REJECTED":
      return "#d32f2f"
    default:
      return "#757575";
  }
}